import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JobTitleApiModel, SyncWithPlatformResultApiModel } from '@app/api/api-models';
import { JobTitleDeleteResultApiModel } from '@app/api/api-models/site-settings/job-titles/JobTitleDeleteResultApiModel';
import { CrudService } from '@app/api/api-services/crud.service';

@Injectable()
export class JobTitlesService extends CrudService<JobTitleApiModel, number> {
  public readonly apiUrl = 'job-titles';

  public deleteJobTitle(id: number): Observable<JobTitleDeleteResultApiModel> {
    return this.http.delete<JobTitleDeleteResultApiModel>(`${this.apiUrl}/delete/${id}`);
  }

  public syncWithPlatform(): Observable<SyncWithPlatformResultApiModel> {
    return this.http.post<SyncWithPlatformResultApiModel>(`${this.apiUrl}/sync-with-platform`, {});
  }
}
